export enum DashboardOutstandingByPOCPivotMode {
    Committed = 'Committed',
    Funded = 'Funded',
    Number = 'Number',
}
